/**
 * App version shown in the app bar, and compared against /version.json to tell an open
 * tab it is running an old build.
 *
 * `npm run deploy:bump` moves this (via scripts/bump-version.mjs), so there is no need
 * to bump it by hand. Bump the major by hand for a real release.
 */
export const APP_VERSION = "5.34";
